import React, { useContext } from "react"
import { Platform } from "react-native"
import TextInputM from "./TextInputM"
import { DimensionsContext } from "../../utils/mobileUtils"

/**
 * A one-time code field: digits only, capped at `length`. No native
 * `maxLength`, on purpose — a pasted « 123 456 » is 7 characters and would be
 * cut before its space is stripped. The OS is told it is a one-time code, so
 * iOS, Android and the browser offer the code from the SMS or email.
 */
export const DigitsCodeInputM = ({
    length,
    control,
    setValue,
    name = "code",
    width,
    placeholder = "Entrez votre code",
    onChangeAdditional,
    ...inputProps
}) => {
    const dimensions = useContext(DimensionsContext)
    const inputWidth = width ?? Math.min(dimensions?.width - 40, 300)

    const handleTextChange = (text) => {
        const digits = text.replace(/[^0-9]/g, "").slice(0, length)
        setValue(name, digits)
        onChangeAdditional?.(digits)
    }

    return (
        <TextInputM
            control={control}
            name={name}
            width={inputWidth}
            keyboardType="number-pad"
            textContentType="oneTimeCode"
            autoComplete={Platform.select({
                android: "sms-otp",
                default: "one-time-code",
            })}
            onChangeAdditional={handleTextChange}
            placeholder={placeholder}
            style={{
                textAlign: "center",
                fontSize: 20,
                fontWeight: "Bold",
                letterSpacing: 8,
            }}
            {...inputProps}
        />
    )
}
